export default {"src":"/_next/static/media/apple-pay-mark.f5254008.svg","height":106,"width":166,"blurWidth":0,"blurHeight":0};